import { z } from "zod";
import { isIsoDate, isIsoWeek } from "../time.js";

export const ERROR_CODES = [
  "not_found",
  "forbidden",
  "unauthorized",
  "invalid",
  "conflict",
  "zvoove_write_blocked",
  "rate_limited",
  "budget_exhausted",
  // A switched-off feature (extension 2: sick reports) answers 404 with this code.
  "feature_disabled",
  "internal",
] as const;
export type ErrorCode = (typeof ERROR_CODES)[number];

export const apiErrorSchema = z.object({
  error: z.object({
    code: z.enum(ERROR_CODES),
    message: z.string(),
    fieldErrors: z.record(z.string(), z.string()).optional(),
  }),
});
export type ApiErrorBody = z.infer<typeof apiErrorSchema>;

// `new Date("2026-02-30")` parses in V8 (as 2 March), so the check has to round-trip the string.
export const isoDateSchema = z.string().refine(isIsoDate, "YYYY-MM-DD");

export const isoTimestampSchema = z.string().refine((value) => {
  const t = Date.parse(value);
  return !Number.isNaN(t) && /[Zz]|[+-]\d{2}:\d{2}$/.test(value);
}, "ISO 8601 timestamp with offset");

export const isoWeekSchema = z.string().refine(isIsoWeek, "YYYY-Www");

export const idSchema = z.string().min(1).max(64);

export const okSchema = z.object({ ok: z.literal(true) });
export type Ok = z.infer<typeof okSchema>;

export const dateRangeQuerySchema = z.object({
  from: isoDateSchema.optional(),
  to: isoDateSchema.optional(),
});
